import { useDrawer } from '@cast/design-system';

import {
  EditEdgeLocationDrawer,
  EditEdgeLocationDrawerProps,
} from './EditEdgeLocationDrawer';

export const useEditEdgeLocationDrawer = () => {
  const { open } = useDrawer();

  return {
    openEditEdgeLocationDrawer: (props: EditEdgeLocationDrawerProps) =>
      open({ component: EditEdgeLocationDrawer, props }),
  };
};
